import styled, { css } from 'styled-components';
import { theme } from '../themes';

export const Styles = css`
  :root {
    --color-primary: ${theme.color.primary};
    --color-primary-light: ${theme.color.primaryLight};
    --color-primary-dark: ${theme.color.primaryDark};
    --color-secondary: ${theme.color.secondary};
    --color-secondary-btn:#4d4d4d;
    --color-secondary-light: ${theme.color.secondaryLight};
    --color-secondary-dark: ${theme.color.secondaryDark};
    --color-gray-darker: hsl(0,0%,15%);
    --color-gray-dark: hsl(0,0%,35%);
    --color-gray-regular: hsl(0,0%,50%);
    --color-gray-light: hsl(0,0%,70%);
    --color-gray-lighter: hsl(0,0%,95%);
    --color-gray-background: ${theme.color.grayBackground};
    --color-info: ${theme.color.info};
    --color-success: ${theme.color.success};
    --color-warning: ${theme.color.warning};
    --color-danger: ${theme.color.danger};
    --color-danger-light: ${theme.color.dangerLight};

    --font-family-base: ${theme.font.default};
    --font-family-headings: ${theme.font.default};
    --font-family-alt: ${theme.font.alt};

    --font-weight-light: ${theme.fontWeight.light};
    --font-weight-book: ${theme.fontWeight.book};
    --font-weight-regular: ${theme.fontWeight.regular};
    --font-weight-medium: ${theme.fontWeight.medium};
    --font-weight-bold: ${theme.fontWeight.bold};
    --font-weight-black: ${theme.fontWeight.black};

    --filter-white: ${theme.filter.white};
    --filter-primary: ${theme.filter.primary};
    --filter-secondary: ${theme.filter.secondary};
    --filter-gray-regular: ${theme.filter.grayRegular};
    --filter-gray-dark: ${theme.filter.grayDark};
    --filter-warning: ${theme.filter.warning};
    --filter-danger: ${theme.filter.danger};
    --filter-success: ${theme.filter.success};

    --base-transition: all 300ms ease-in-out;
    --base-border-radius: 4px;
    --base-box-shadow: 0 0 6px rgb(0 0 0 / 15%);

    --breakpoint-medium: 600px;


    --color-rojo:  rgb(204,55,35);
    --color-azul:  rgb(40,45,96);
    --color-blanco:  rgb(255,255,255);
    --color-negro:  rgb(0,0,0);
    --color-gris:  rgb(222,222,222);
    --color-gris-secundario:  rgb(171,163,163);
    --color-gris-extra:  #f2f2f2;

  }
`

export default Styles

